import { Component, effect, OnInit } from '@angular/core';
import { ConversationService } from 'src/app/shared/services/conversation/conversation.service';
import { FormsModule } from '@angular/forms';
import { NgIf, NgFor } from '@angular/common';
interface CustomFile {
  name: string;
  file?: File;
  url?: string;
}

interface CustomConfig {
  css: CustomFile[];
  javascript: CustomFile[];
  googleAnalyticsCode: string;
}

@Component({
    selector: 'app-litmus-intraction-custom',
    templateUrl: './litmus-intraction-custom.component.html',
    styleUrl: './litmus-intraction-custom.component.scss',
    imports: [FormsModule, NgIf, NgFor]
})
export class LitmusIntractionCustomComponent implements OnInit {
  customConfig: CustomConfig = {
    css: [{ name: '' }],
    javascript: [{ name: '' }],
    googleAnalyticsCode: ''
  };

  customConfigUrl: { css: string[], javascript: string[] } = {
    css: [],
    javascript: []
  };

  constructor(private _conversation: ConversationService) {
    effect(() => {
      const conversationObject: any = this._conversation.conversationObject()
      if (conversationObject) {
        if (conversationObject.hasOwnProperty('files')) {
          this.customConfigUrl.css = (conversationObject.cssUrl) ? [conversationObject.cssUrl] : [];
          this.customConfigUrl.javascript = (conversationObject.jsUrl) ? [conversationObject.jsUrl] : [];
          this.customConfig.googleAnalyticsCode = conversationObject.configuration['google_analytics_code'] || "";
        }
      }
    })
  }

  ngOnInit(): void {


    // In a real implementation, this would fetch configuration from an API
    // Populate with dummy data for preview
    this.customConfigUrl.css = [];
    this.customConfigUrl.javascript = [];
  }

  onFileSelect(event: any, type: 'css' | 'javascript'): void {
    const files = event.target.files;
    if (files && files.length > 0) {
      const fileObject = files[0];
      this.customConfig[type][0] = fileObject
      console.log("fileObject", fileObject)
      this._conversation.customConfig = this.customConfig

      // In a real implementation, this would upload the file to a server
      // and update customConfigUrl with the response URL

      // Simulate a successful upload
      // setTimeout(() => {
      //   this.customConfigUrl[type].push(`/assets/sample-${type}-file.${type}`);
      // }, 500);
    }
  }

  removeItem(type: 'local' | 'remote', fileType: 'css' | 'javascript'): void {
    if (type && (fileType === 'css' || fileType === 'javascript')) {
      var arrayKey = this._conversation.checkFileTypeObject(fileType);
      switch (type) {
        case 'local': {
          if (this.customConfigUrl[arrayKey.local].length > 0) {
            this.customConfig[arrayKey.local] = [];
          }
          break;
        }
        case 'remote': {
          this._conversation.files[arrayKey.remote] = [];
          if (this._conversation.hasOwnProperty(arrayKey.url)) {
            this._conversation[arrayKey.url] = "";
          }
          this._conversation.configuration[arrayKey.configPath] = [];
          this._conversation.set(this._conversation.configuration);
          this.customConfigUrl[arrayKey.local].splice(0, 1);
          break;
        }
      }
      this._conversation.set(this._conversation.configuration);
    }
  }

  updateGoogleAnalyticsCode(event: any) {
    if (this._conversation.hasOwnProperty('configuration')) {
      this._conversation.configuration['google_analytics_code'] = this.customConfig.googleAnalyticsCode;
      this._conversation.set(this._conversation.configuration)
    }
  }

  saveConfig(publish: boolean = false): void {
    console.log('Saving configuration:', this.customConfig);
    console.log('URLs:', this.customConfigUrl);
    console.log('Publish:', publish);

    // In a real implementation, this would send the configuration to an API
    alert(`Configuration ${publish ? 'saved and published' : 'saved'} successfully!`);
  }
}
